<template>
  <div 
    class="container spacing img-landing-phone"
  >
    <img
      :src="img"  
      style="padding-bottom:0.5em;"
    >
    <p class="text-primary">
      <b>{{ caption }}</b>
    </p>
  </div>
</template>

<script>

export default {
  name: 'LandingPageImage',
  props: {
    name: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    caption: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>

<style lang="scss" src="../img.scss">
</style>
